export default "__VITE_ASSET__5b3587c4__"